import { render, staticRenderFns } from "./CRStatus.vue?vue&type=template&id=14c2fbec&"
import script from "./CRStatus.vue?vue&type=script&lang=js&"
export * from "./CRStatus.vue?vue&type=script&lang=js&"
import style0 from "./CRStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports